import React from "react";
import { useKeyPressEvent } from "react-use";
import { ReferenceArea } from "recharts";

import { getTime } from "~/tools/date-time";
import { useScoped } from "~/tools/impulse";
import { theme } from "~/tools/twin-migration";
import { useHandler } from "~/tools/use-handler";

import type { State } from "./state";

interface BrushAreaProps {
	state: State;
	offsetTop: number;
}

export const BrushArea: React.FC<BrushAreaProps> = React.memo(({ state, offsetTop }) => {
	const interval = useScoped((scope) => state.interval.getValue(scope), [state]);

	if (interval == null) {
		return null;
	}

	return (
		<ReferenceArea
			fill={theme("colors.blue.200")}
			fillOpacity={0.15}
			shape={(props) => <Shape state={state} {...props} height={props.height + offsetTop} y={props.y - offsetTop} />}
			stroke={theme("colors.blue.600")}
			x1={getTime(interval.start)}
			x2={getTime(interval.end)}
		/>
	);
});

const Shape: React.FC<{
	state: State;
	x: number;
	y: number;
	width: number;
	height: number;
	fillOpacity: number;
	fill: string;
	stroke: string;
}> = ({ state, x, y, width, height, fillOpacity, fill, stroke }) => {
	useKeyPressEvent(
		"Escape",
		useHandler(() => {
			state.onBrushEnd();
		}),
	);

	return (
		<g>
			<rect fill={fill} fillOpacity={fillOpacity} height={height} width={width} x={x} y={y} />
			<line stroke={stroke} x1={x} x2={x} y1={y} y2={y + height} />
			<line stroke={stroke} x1={x + width} x2={x + width} y1={y} y2={y + height} />
		</g>
	);
};
